import { FC, useState } from "react";

import type { AcceleratorOscillatorSettings } from "../../model";

import styles from "./AcceleratorOscillatorInputsTab.module.css";

type InputKey = "aoShortPeriod" | "aoLongPeriod" | "acSmaPeriod";
type InputValues = Record<InputKey, string>;

const FIELDS: { key: InputKey; label: string; min: number; max: number }[] = [
  { key: "aoShortPeriod", label: "AO Short Period", min: 1, max: 200 },
  { key: "aoLongPeriod", label: "AO Long Period", min: 1, max: 200 },
  { key: "acSmaPeriod", label: "AC SMA Period", min: 1, max: 100 },
];

interface Props {
  settings: AcceleratorOscillatorSettings;
  onChange: (settings: AcceleratorOscillatorSettings) => void;
}

export const AcceleratorOscillatorInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [values, setValues] = useState<InputValues>({
    aoShortPeriod: String(settings.aoShortPeriod),
    aoLongPeriod: String(settings.aoLongPeriod),
    acSmaPeriod: String(settings.acSmaPeriod),
  });

  const handleChange = (key: InputKey, value: string) => {
    setValues((prev) => ({ ...prev, [key]: value }));
  };

  const handleBlur = (key: InputKey, max: number) => {
    const parsed = parseInt(values[key], 10);
    const clamped = isNaN(parsed) ? settings[key] : Math.min(Math.max(1, parsed), max);
    setValues((prev) => ({ ...prev, [key]: String(clamped) }));
    onChange({ ...settings, [key]: clamped });
  };

  return (
    <div className={styles.tab}>
      {FIELDS.map(({ key, label, min, max }) => (
        <div key={key} className={styles.row}>
          <span className={styles.label}>{label}</span>
          <input
            type="number"
            className={styles.input}
            min={min}
            max={max}
            value={values[key]}
            onChange={(e) => handleChange(key, e.target.value)}
            onBlur={() => handleBlur(key, max)}
          />
        </div>
      ))}
    </div>
  );
};
